import api from './api';
export interface IncrementalityReport {
  status: 'AVAILABLE' | 'UNAVAILABLE'; currency: string; from: string; to: string; observedAt: string;
  incrementalContributionProfitPerEligibleRecipient: string | null; reasonCodes: string[];
  inferenceStatus: 'POSITIVE' | 'NEGATIVE' | 'INCONCLUSIVE'; inferenceReasonCodes: string[];
  confidenceInterval: null | { lower: string; upper: string };
  minimumSample: null | { treatment: number; control: number };
  groups: Array<{ group: 'TREATMENT' | 'CONTROL'; assignmentCount: number; eligibleRecipientCount: number | null;
    documentedEligibleCount: number; unknownEligibilityCount: number; observedPaidOrderCount: number;
    availableContributionOrderCount: number; knownOrderContributionProfit: string | null;
    contributionProfitAfterMarketingCost: string | null }>;
  financeHistory: { status: string; orders: Array<{ factId: string; orderRef?: string | null; status: string; revisionId?: string; contentIntegrity?: 'VERIFIED' | 'LEGACY_UNVERIFIABLE';
    recordedAt?: string; reconciliation?: { reportedPaidAmount: string | null; observedNetPayment: string | null } }> };
}
export const marketingIncrementalityApi = {
  list: (brandId: string, storeId: string, cursor?: string) => api.get<{
    items: Array<{ id: string; experimentKey: string; experimentVersion: number; kind: string;
      inferencePlan?: null | { cohortFrom: string; cohortTo: string; analyzeAfter: string } }>; nextCursor: string | null;
  }>(`/marketing/brands/${encodeURIComponent(brandId)}/experiments`, { params: { storeId, cursor, limit: 100 } }),
  report: (brandId: string, definitionId: string, query: { storeId: string; currency: string; from: string; to: string }) =>
    api.get<IncrementalityReport>(`/marketing/brands/${encodeURIComponent(brandId)}/experiments/${encodeURIComponent(definitionId)}/incrementality`, { params: query }),
};
